import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';

import {
  MarriottStoreHeroComponent
} from '@ux/components/marriott-store-badge/components/marriott-store-hero/marriott-store-hero.component';
import { 
  MarriottWelcomeBannerComponent
} from '@ux/components/marriott-store-badge/components/marriott-welcome-banner/marriott-welcome-banner.component';

@NgModule({
  declarations: [
    MarriottStoreHeroComponent,
    MarriottWelcomeBannerComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
  ],
  exports: [
    MarriottStoreHeroComponent,
    MarriottWelcomeBannerComponent
  ]
})
export class MarriottStoreBadgeModule { }
